import type { BannerActualidad, BannerFundaciones, Home, Image } from '@/interfaces/strapi';
import type { StrapiHomeModel } from '@/interfaces/model';
import { mapImage } from '@/helpers/strapi-assets-helpers';

export const homeMapper = (data: StrapiHomeModel): Home => {
	const heroBlock = Array.isArray(data.hero) ? data.hero[0] : undefined;
	const images = heroBlock?.images?.map((img) => mapImage(img)) ?? [];

	const bannerArray: BannerActualidad[] = (data.banner ?? []).map(
		(item): BannerActualidad => ({
			title: item.titulo,
			description: item.descripcion,
			url: item.url,
		}),
	);

	const bannerFundacionesArray: BannerFundaciones[] = (data.bannerFundaciones ?? []).map(
		(item): BannerFundaciones => ({
			title: item.titulo,
			description: item.descripcion,
			image: mapImage(item.image),
		}),
	);

	return {
		id: data.id,
		title: data.title,
		description: data.description,
		hero: {
			id: heroBlock?.id ?? data.id,
			text: heroBlock?.text ?? '',
			images,
		},
		banner: bannerArray,
		bannerFundaciones: bannerFundacionesArray,
	};
};
